/* @flow */
import * as React from 'react';
import type { TFunction } from 'react-i18next';
import type { ImportCreatedWithoutAccount } from 'api/brandsBulkImport';
import styles from './ImportShared.module.scss';

type TypeProps = {
  brands: ImportCreatedWithoutAccount[],
  t: TFunction,
};

const ImportCreatedWithoutAccounts = ({ brands, t }: TypeProps): React.Node => {
  if (!brands || brands.length === 0) {
    return null;
  }

  return (
    <div className={styles['import-created-without-accounts']}>
      <h5 className={styles['import-created-without-accounts__heading']}>
        {t('general:reporting.brand_form.multiple.labels.created_without_accounts')}
      </h5>
      <ul className={styles['import-created-without-accounts__list']}>
        {brands.map(brand => (
          <li key={brand.id} className={styles['import-created-without-accounts__item']}>
            <span className={styles['import-created-without-accounts__name']}>{brand.name}</span>
            <span className={styles['import-created-without-accounts__count']}>
              {t('general:reporting.brand_form.multiple.labels.account_count', {
                count: brand.account_count || 0,
              })}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ImportCreatedWithoutAccounts;
